/**
 * Extracts main route and children routes from a parent route
 */
export const extractRoute = ({ path, ...route }) => {
  const parentPath =
    typeof path !== 'undefined'
      ? `${path.startsWith('/') ? '' : '/'}${path}`
      : undefined

  const children = (route.children ?? []).reduce(
    (children, child) => [
      ...children,
      ...extractRoute({
        ...child,
        path: `${parentPath}${child.path.startsWith('/') ? '' : '/'}${
          child.path
        }`,
      }),
    ],
    []
  )

  return [
    {
      ...route,
      children,
      path: parentPath
    },
    ...children,
  ]
}

/**
 * Extracts all routes from the route tree as unidimentional array
 */
export const extractRoutes = (routes) => { 
  const unorderedRoutes = routes
  .reduce((routes, r) => [...routes, ...extractRoute(r)], [])
  .map((r) => ({
    ...r,
    pattern: new URLPattern({ pathname: r.path }),
  }))

  const orderedRoutes = unorderedRoutes
    .filter(r => r.name != "404")
    .sort((r) => -`${r.path ?? ''}`.split('/').length)
    .sort((a, b) => a.path.split(':').length > b.path.split(':').length ? 1 : -1)
  
  orderedRoutes.push(unorderedRoutes.find(r => r.name == "404"))

  return orderedRoutes;
}
    
